<!--
 * @Description:
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-18 16:03:56
 * @LastEditors: lau
 * @LastEditTime: 2022-08-18 17:22:53
-->
<!--
 * @Description:
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-18 15:17:10
 * @LastEditors: lau
 * @LastEditTime: 2022-08-18 15:27:14
-->
<!--
 * @Description:
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-18 14:24:52
 * @LastEditors: lau
 * @LastEditTime: 2022-08-18 14:47:28
-->
<!-- 查询线上月票接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody: {

            },
            responseCode: {

            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台添加月票访客授权",
                t_url: this.commonUrls.test + "allowBuyMonthlyTicket",
                p_url: this.commonUrls.prod + "allowBuyMonthlyTicket",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编码' },
                        { info1: 'monthTicketTypeId', info2: '是', info3: 'Long', info4: '月票类型id' },
                        { info1: 'monthTicketId', info2: '否', info3: 'Long', info4: '月票id (续费月票时,此字段必填)' },
                        { info1: 'plateLists', info2: '是', info3: 'Integer', info4: '月票车牌信息' },
                        { info1: 'timePeriods', info2: '是', info3: 'Integer', info4: '月票有效时间' },
                        { info1: 'mobile', info2: '否', info3: 'String', info4: '车主手机号码,月票凭证验证需要' },

                    ]
                },{
                  titleName: 'plateLists 列表',
                  tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                  td: [
                    { info1: 'plate', info2: '是', info3: 'String', info4: '车牌号码' },
                    { info1: 'plateColor', info2: '否', info3: 'Integer', info4: '车牌颜色  0其他，1蓝色，2黄色，3白色，4黑色，5绿色' },
                  ]
                },{
                  titleName: 'timePeriods 列表',
                  tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                  td: [
                    { info1: 'startTime', info2: '是', info3: 'datetime', info4: '月票有效开始时间yyyyMMdd' },
                    { info1: 'endTime', info2: '是', info3: 'datetime', info4: '月票有效结束时间yyyyMMdd' },
                  ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'code', info2: '是', info3: 'Integer', info4: '200可开通 其它状态值为不可开通的具体原因'},
                        { info1: 'msg', info2: '是', info3: 'String', info4: '结果说明 '},

					   ]
                },{
                  titleName: '状态码列表',
                  tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                  td: [
                    { info1: '200', info2: '否', info3: 'Integer', info4: '可开通' },
                    { info1: '301', info2: '否', info3: 'Integer', info4: '不存在该月票类型' },
                    { info1: '302', info2: '否', info3: 'Integer', info4: '该月票已失效' },
                    { info1: '303', info2: '否', info3: 'Integer', info4: '超过月票类型的有效期，无法开通' },
                    { info1: '304', info2: '否', info3: 'Integer', info4: '黑名单不允许月票' },
                    { info1: '305', info2: '否', info3: 'Integer', info4: '该月票暂不支持线上开通' },
                    { info1: '306', info2: '否', info3: 'Integer', info4: '该月票暂不支持线上续费' },
                    { info1: '307', info2: '否', info3: 'Integer', info4: '月票已售罄' },
                    { info1: '308', info2: '否', info3: 'Integer', info4: '请勿重复购买' },
                    { info1: '309', info2: '否', info3: 'Integer', info4: '月票可续费时间已截止' },
                    { info1: '310', info2: '否', info3: 'Integer', info4: '月票续费时间不能超过yyyy-MM-dd' },
                    { info1: '311', info2: '否', info3: 'Integer', info4: '月票名额不足' },
                    { info1: '312', info2: '否', info3: 'Integer', info4: '月票时间冲突' },
                    { info1: '313', info2: '否', info3: 'Integer', info4: '只能按自然月购买' },
                  ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/query/allowBuyMonthlyTicket.vue